<template>
  <v-container>
    <v-row class="align-stretch">
      <v-col v-for="item in items" :key="item.id" :md="3">
        <dress-card :item="item" @click="navigate" />
      </v-col>
    </v-row>
    <div class="text-center">
      <v-pagination
        v-model="page"
        :length="pages || 1"
        v-if="pages"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import DressCard from "../components/DressCard";

export default {
  name: "Home",
  components: {
    DressCard
  },
  data: () => ({
    itemsPerPage: 24,
    page: 1
  }),
  computed: {
    items: function() {
      return this.$store.getters.listDress;
    },
    model: function() {
      return this.$store.getters.modelDress;
    },
    total: function() {
      return this.$store.getters.totalDress;
    },
    pages: function() {
      return Math.ceil(this.total / this.itemsPerPage);
    },
    where: function() {
      let search = this.$store.getters.searchstring.toLowerCase();
      let filter = this.$store.getters.filter;
      
      let res = Object.keys(filter).length ? {...filter }: {}
      if(search.length > 1) res.search = { contains: search }

      return res;
    }
  },
  mounted() {
    this.$store.dispatch("loadModelDress");
    this.loadData();
  },
  watch: {
    page: {
      handler() {
        this.loadData();
      }
    },
    where: {
      handler() {
        this.loadData();
      }
    }
  },
  methods: {
    navigate(id) {
      this.$router.push({ path: "/dress/" + id });
    },
    loadData() {
      this.$store.dispatch("findDress", {
        limit: this.itemsPerPage,
        skip: (this.page - 1) * this.itemsPerPage,
        where: JSON.stringify(this.where)
      });
    }
  }
};
</script>
